<template>
  <common-dialog ref="dialog" width="720px" title="手工录入订单" id-key="id" form-label-width="110px" :data="data"
    @opened="onOpened" @create-opened="onCreateOpened" @edit-opened="onEditOpened" :form-rules="rules"
    :save-func="saveDataFunc" @close-saved="$emit('close-saved')" close-on-saved @closed="onClosed">
    <template slot="form">
      <template v-if="!data.isPrint">
        <el-form-item label="订单号" prop="orderSn">
          <div style="display: flex;" v-if="data.id == 0">
            <el-input style="width: calc(100% - 80px);" v-model="data.orderSn"
              placeholder="输入订单号，点击“自动关联”，会自动填充收件人信息"></el-input>
            <el-button type="primary" style="margin-left: 10px;" @click="onLink">自动关联</el-button>
          </div>
          <el-input v-else v-model="data.orderSn" disabled></el-input>
        </el-form-item>
        <el-form-item label="智能地址识别">
          <div style="display: flex;">
            <el-input type="textarea" style="width: calc(100% - 80px);" v-model="identification"
              placeholder="请按照“姓名 电话 地址”顺序粘贴或填写，中间需要用空格隔开，如：张三 15000000000 上海市长宁区茅台路1010号3-5"></el-input>
            <el-button type="primary" style="margin-left: 10px;width: 80px;height: 28px;"
              @click="onIdentification">识别</el-button>
          </div>
        </el-form-item>
      </template>
      <el-form-item label="收件人" prop="receiverName">
        <el-input v-model="data.receiverName" :disabled="data.type == 20" placeholder="请输入收件人"></el-input>
      </el-form-item>
      <el-form-item label="省市区" prop="addressCode">
        <address-select style="width: 100%;" v-model="data.addressCode" :disabled="data.type == 20"
          :placeholder="'请选择城市'" @change="onAddressSelect" />
      </el-form-item>
      <el-form-item label="详细地址" prop="address">
        <el-input v-model="data.address" :disabled="data.type == 20" placeholder="请输入详细地址"></el-input>
      </el-form-item>
      <el-form-item label="联系方式" prop="receiverPhone">
        <el-input v-model="data.receiverPhone" :disabled="data.type == 20" placeholder="请输入联系方式"></el-input>
      </el-form-item>
      <template v-if="!data.isPrint">
        <el-form-item label="商品信息" prop="goodsName">
          <el-input v-model="data.goodsName" placeholder="请输入商品信息"></el-input>
        </el-form-item>
        <el-form-item label="商品数量" prop="goodsCount">
          <el-input v-model="data.goodsCount" placeholder="请输入商品数量"></el-input>
        </el-form-item>
        <el-form-item label="重量（kg）" prop="goodsWeight">
          <el-input v-model="data.goodsWeight" placeholder="请输入重量"></el-input>
        </el-form-item>
        <el-form-item label="备注信息" prop="note">
          <el-input v-model="data.note" placeholder="请输入备注信息"></el-input>
        </el-form-item>
      </template>
    </template>
    <template slot="footer">
      <el-button type="primary" @click="save">保 存</el-button>
      <template v-if="!data.isPrint">
        <el-button type="primary" @click="saveAndPrint">保存并打印</el-button>
        <el-button type="primary" @click="saveAndCreate">保存并继续创建</el-button>
      </template>
      <el-button @click="close">关 闭</el-button>
    </template>
  </common-dialog>
</template>
<script>
import { data } from 'jquery';
import editDialogMixin from '../mixins/editDialog'; //部分相同的逻辑使用代码混入

export default {
  mixins: [editDialogMixin],
  data() {
    return {
      api: require("@/api/wx/manualorder").default,
      orderApi: require("@/api/wx/order").default,
      data: {
        id: 0,
        /** 类型 10：手工，20：关联 */
        type: 10,
        /** 已打印 */
        isPrint: false,
        /** 订单编号（可选） */
        orderSn: null,
        /** 地址编码 省/市/区 00/0000/000000 */
        addressCode: null,
        /** 国家（可选） */
        country: null,
        /** 省 */
        province: null,
        /** 市 */
        city: null,
        /** 区、乡镇 */
        district: null,
        /** 街道（可选） */
        street: null,
        /** 详细地址，不含 国家 省 市 区 街道 */
        address: null,
        /** 收货人 */
        receiverName: null,
        /** 收货电话 */
        receiverPhone: null,
        /** 商品名称 */
        goodsName: null,
        /** 商品数量 */
        goodsCount: null,
        /** 商品重量（kg） */
        goodsWeight: null,
        /** 备注 */
        note: null,
      },
      identification: "",
      rules: {
        orderSn: [{ required: true, message: '订单号不能为空' }],
        addressCode: [{ required: true, message: '请选择省市区' }],
        address: [{ required: true, message: '详细地址不能为空' }],
        receiverName: [{ required: true, message: '收件人不能为空' }],
        receiverPhone: [{ required: true, message: '联系方式不能为空' }],
      },
    };
  },
  methods: {
    onCreateOpened() {

    },
    onEditOpened(data) {
      console.log("onEditOpened1", JSON.parse(JSON.stringify(data)));
      console.log("onEditOpened2", JSON.parse(JSON.stringify(this.data)));
      // var x = data.receiverAddress;
      // var addressName = x.province + x.city + x.district;
      // if (addressName) this.data.addressCode = this.getAddressCodeByName(addressName);
    },
    onLink() {
      console.log("关联");
      if (!this.data.orderSn) {
        this.$message.warning("请输入订单号");
        return;
      }
      // 2210279991733516957
      this.orderApi.getOrders({ orderSn: this.data.orderSn }).then(res => {
        if (res.data && res.data.length > 0) {
          this.data.type = 20; // 关联
          var order = res.data[0];

          var addressName = order.province + order.city + order.district;
          this.data.addressCode = this.getAddressCodeByName(addressName);

          this.data.province = order.province;
          this.data.city = order.city;
          this.data.district = order.district;
          this.data.street = order.town;

          this.data.receiverName = order.receiverName;
          this.data.receiverPhone = order.receiverPhone;

          if (this.data.street) this.data.address = order.town + order.address
          else this.data.address = order.address;
        } else {
          this.$message.error("订单不存在");
          this.data.addressCode = "";
          this.data.province = "";
          this.data.city = "";
          this.data.district = "";
          this.data.street = "";
          this.data.receiverName = "";
          this.data.receiverPhone = "";
          this.$refs.dialog.clearValidate();
        }
      })
    },
    onIdentification() {
      if (!this.identification) {
        this.$message.warning("请输入要识别的内容");
        return;
      }
      if (this.data.type == 20) {
        this.$message.warning("关联订单不能修改地址信息");
        return;
      }
      const info = this.getAddressInfo(this.identification);
      console.log(info);
      this.data.addressCode = info.provinceCode + "/" + info.cityCode + "/" + info.countyCode;

      this.data.province = info.province;
      this.data.city = info.city;
      this.data.district = info.county;
      this.data.street = info.street;

      this.data.receiverName = info.name;
      this.data.receiverPhone = info.phone;

      if (info.street) this.data.address = info.street + info.address
      else this.data.address = info.address;
    },
    onAddressSelect(e) {
      // this.data.省市区文本 = e.map(x => x.label).join("/");
      console.log("省市区", e);
      console.log("addressCode", this.data.addressCode);

      this.data.province = e[0].label;
      this.data.city = e[1].label;
      this.data.district = e[2].label;
    },
    onSave() {
      console.log("save", this.data)
      return new Promise((resolve, reject) => {
        var func = this.api.postManual;
        if (this.data.id != 0) func = this.api.putManual;
        func(this.data, this.mallToken).then(res => {
          if (res) this.data.id = res;
          resolve({ Code: 0, Msg: null })
        }).catch(err => {
          resolve({ Code: 1, Msg: res.errorMessage })
        })
      })
    },
  },
};
</script>
